
export const ThemeFrameworkCommon = {
    successColor: '#27ae60',
    warningColor: '#c4ab1a',
    errorColor: '#c41a1a',
    grayColor: '#adadad',
}
